<div class="row">
    <div class="col-sm-4">
    <ul class="list-group list-group-flush">
    <li class="list-group-item"><a href="#about-us">About Us</a></li>

    <li class="list-group-item"><a href="#contact-us"> Contact Us</a></li>
    </ul>

    </div>
       <div class="col-sm-8 landing-overview">
       <a id="about-us"></a>
       <h2>About Us</h2>

  Boldungu’s mission is to create a world where every child enjoys and achieves the maximum potential in science, technology, engineering and mathematics (STEM). We think of a world where children/learners can practice, refresh their STEM skills from any where at anytime and only go to physical school for new concepts or soft skills.
   We enable parents to closely become a major part of what their children are doing on a routine basis.  We imagine a parent/guardian who is able to create quiz cycles targeting specific concepts for a child to complete.
  Learning of mathematics can be fun, and we aspire to create an environment where parents/guardians create fun with their children as while learning mathematics.

  Boldungu is both a research and development project aimed to enhance performance in mathematics. The development comprises of volunteers over a period of time.
  <a ref="https://cocis.mak.ac.ug/boldungu-app-to-help-pupils-practice-and-improve-mathematics-performance/"> Some of the members that have participated in the project can be found  here  </a>

<h3>Contact Us</h3>

email: benjamin.kanagwa@mak.ac.ug <br/>
phone: +256 776 495020

       </div>
 </div>
